import { EstopStateEnum } from './estopStateEnum.js';
import './estopModal.css';
import { Pages } from '@src/Pages.js';
import { Headset } from '@src/assets';
import { renderToStaticMarkup } from 'react-dom/server';

/**
 * Creates an estop modal.
 *
 * @returns {{
 *   modal: jQuery,
 *   showModal: (status: EstopStateEnum) => void,
 *   hideModal: () => void
*  setNavigateFunction: (pNavigate: import('react-router-dom').NavigateFunction) => void
 * }} The modal and its controls.
 */
export function createEstopModal () {
  let navigate;
  $('.estop-background').remove();

  const lModalBackground = $('<div class="estop-background">'); // grey background
  const lModal = $('<div class="estop-modal">'); // estop modal
  const lTitleContainer = $('<div class="estop-modal-title">');
  const lBody = $('<div class="estop-modal-body">');

  // step 1
  const stepOne = $('<div class="estop-step">');
  const stepOneDetails = $('<div>')
    .addClass('estop-step-details')
    .html(`
      <h5>STEP 1</h5>
      <p>
        Ensure all safety devices are released
        <br>
        <span>(Pendant, E-Stop module, third party safety devices)</span>
      </p>
    `);
  const stepOneImage = $('<div>')
    .addClass('estop-step-image')
    .html(`
      <img src="../../vse/images/estop-release.png"></img>
    `);

  stepOne.append(
    stepOneDetails,
    stepOneImage,
  );

  // step 2
  const stepTwo = $('<div class="estop-step">');
  const stepTwoDetails = $('<div>')
    .addClass('estop-step-details')
    .html(`
    <h5>STEP 2</h5>
    <p>Press the blue reset button on your E-Stop module</p>
  `);
  const stepTwoImage = $('<div>')
    .addClass('estop-step-image')
    .html(`
      <img src="../../vse/images/estop-reset.png"></img>
    `);

  stepTwo.append(
    stepTwoDetails,
    stepTwoImage,
  );

  const remoteSupportButton = $('<div>');

  $('body').append(
    lModalBackground.append(
      lModal.append(
        lTitleContainer,
        lBody.append(
          stepOne,
          stepTwo,
        ),
      ),
      remoteSupportButton,
    ),
  );

  lModalBackground.hide();

  function returnToMeetingButton () {
    return $('<button>')
      .addClass('estop-return-to-remote-support-button')
      .text('Return to Support Meeting')
      .on('click', () => {
        if (navigate === undefined) {
          throw new Error('EstopModal: navigate function not set');
        }
        navigate(Pages.REMOTE_SUPPORT);
      });
  }

  function callRemoteSupportButton () {
    return $('<div>').addClass('estop-call-remote-support-widget')
      .append(
        $('<span>').addClass('need-help-text').text('Need Help?'),
        $(renderToStaticMarkup(Headset())),
        $('<button>').addClass('call-remote-support-button').text('Call Remote Support').on('click', () => {
          if (navigate === undefined) {
            throw new Error('EstopModal: navigate function not set');
          }
          navigate(Pages.REMOTE_SUPPORT);
        }),
      );
  }

  /**
   * shows the estop modal with the correct title based on the estop status provided.
   * @param {EstopStateEnum} pEstopStatus
   * @param {boolean} pIsInSupportCall
   */
  function lShowModal (pEstopStatus, pIsInSupportCall) {
    let lTitle = $('<div>').text('E-Stop State Unknown');
    if (pEstopStatus === EstopStateEnum.Triggered) {
      lTitle = $('<div>').html('<i class="fas fa-exclamation-triangle estop-icon"></i> E-Stop Activated');
    }

    lTitleContainer
      .empty()
      .append(
        lTitle,
      );

    remoteSupportButton
      .empty()
      .append(pIsInSupportCall ? returnToMeetingButton() : callRemoteSupportButton());

    lModalBackground.show();

    // Focus out currently focused element
    // select types do not support z-index, so they would always appear on top of the modal.
    // see ticket VentionCo/mm-vention-control/issues/671
    document.activeElement.blur();
  }

  /**
   * hides the estop modal
   */
  function lHideModal () {
    lModalBackground.hide();
  }

  window.showEstopModal = lShowModal;
  window.hideEstopModal = lHideModal;

  return {
    modal: lModalBackground,
    showModal: lShowModal,
    hideModal: lHideModal,
    setNavigateFunction: (pNavigate) => { navigate = pNavigate; },
  };
}
